// import { useHistory } from 'react-router';
import { Button } from '../../../shared/formElements/button';
import * as Yup from 'yup';
import {
  Form,
  FormContainer,
  FormSectionContainer,
  ButtonGroupContainer,
  SectionContainer,
  LoadingSpinner,
  Line,
} from '../../../shared/Layout.styles';
import { Markdown } from '../../../shared/markdown';
import { useForm, FormProvider } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { useContextDispatch, useContextState } from '../../context/context';
import { PinValidationInputs } from './sections';
import { useCallback, useRef, useState } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import axios, { AxiosRequestConfig } from 'axios';
import { resetPinConstants } from '../../../utils/constants/resetPin';
import { OTPModal } from '../../modals';
const {
  eaid,
  phone,
} = resetPinConstants.validations;


declare global {
  interface Window {
    grecaptcha: any;
  }
}

type ModalState = {phone: string | null, open: false, token: string | null} | {phone: string, token: string | null, open: true,  resolve: (result: boolean) => void}

export const SetPin = () => {
  const dispatch = useContextDispatch();
  const { loading } = useContextState();
  const [captchaToken, setCaptchaToken] = useState<string>("");
  const [isCaptchaCompleted, setCaptchaCompleted] = useState(false);
  const recaptcha = useRef<ReCAPTCHA>(null);

  const resetCaptcha = useCallback(() => {
    recaptcha.current?.reset();
    setCaptchaCompleted(false);
    setCaptchaToken("");
  }, []);

  const handleCaptchaChange = useCallback((value: string | null) => {
    setCaptchaCompleted(Boolean(value));
    setCaptchaToken(value || "");
  }, []);

  const [serverErrors, setServerErrors] = useState('');
  const [serverSuccess, setServerSuccess] = useState('');
  const [serverAuthSuccess, setServerAuthSuccess] = useState(false);
  const [modalState, setModalState] = useState<ModalState>({phone: null, open: false, token: null})
  

  const {
    heading,
    subHeading,
  } = resetPinConstants;


  const methods = useForm({
    mode: 'onBlur',
    reValidateMode: 'onChange',
    resolver: yupResolver(validationSchema),
    shouldFocusError: false,
    defaultValues: {
      eaid: '',
      phone: '',
      pinCode: '',
      cardId: undefined,
      token: ''
    },
  });
  const handleClose = () => {
    if (modalState.open) {
      modalState.resolve(true)
      setModalState({phone: '',open: false, token:null})
    }
  }
  const handleIsAuthed = (token:string | null) => {
    if (modalState.open) {
      modalState.resolve(true)
      setModalState({phone: '',open: false, token:token})
    }
  }

  const authHeader = (token: string | null) => {
    // return auth header with jwt if a OTP was required for activation
    if (token !== null && token !== undefined){
      return { Authorization: `Bearer ${token}` };
    } else {
      return {};
    }
  }

  const onSubmit = useCallback(async (formData: any) => {
    if (!isCaptchaCompleted) {
      setServerErrors('Captcha not verified');
      return;
    }
    try {
      dispatch('START_LOADING');
      setServerSuccess('');
      setServerErrors('');
      const data = {
        eaid: formData.eaid,
        phone: formData.phone,
        cardId: formData.cardId,
        pinCode: formData.pinCode,
        captchaToken: captchaToken
      };
      let config: AxiosRequestConfig = {
        headers: {
          'X-API-Key': process.env.REACT_APP_VAULT_API_KEY || ''
        },
      };

      if (modalState.token) {
        config = {
          ...config,
          headers: {
            ...config.headers,
            ...authHeader(modalState.token),
          },
        };
      }
      const resp = await axios.post('/v1/resetpin', data, config);
      debugger
      if (resp.status === 201) {
        await new Promise((resolve) => {
          setModalState({open: true, token: null, phone: formData.phone, resolve})
        } )
      }
      if (resp.status === 200){
        setServerAuthSuccess(true);
        setServerSuccess('PIN successfully set!');
      }
      dispatch('STOP_LOADING');
    } catch (err: any) {
      resetCaptcha()
      if (err && err?.response?.status === 400 && err?.response?.data?.message) {
        setServerErrors(err?.response?.data?.message);
      } else if (err && err.message) {
        setServerErrors(err.message);
      } else {
        setServerErrors("Unknown Error");
      }
      dispatch('STOP_LOADING');
    }
  }, [dispatch, isCaptchaCompleted, modalState.token, resetCaptcha, captchaToken]);

  return (
    <>
        <Line />
      { modalState.open && <OTPModal {...modalState} handleClose={handleClose} handleIsAuthed={handleIsAuthed} /> }
        <FormProvider {...methods}>
          <Form onSubmit={methods.handleSubmit(onSubmit)}>
            <SectionContainer>
              <Markdown children={heading} />
              <Markdown children={subHeading} />
              
              <FormContainer>
                <FormSectionContainer className="resetPinValidateSection">
                 {serverSuccess ? (
                    <Markdown
                      children={serverSuccess}
                      className="successText"
                    />
                  ) : <PinValidationInputs serverAuthSuccess={serverAuthSuccess} token={modalState.token} />}
                  {serverErrors && (
                    <Markdown
                      children={serverErrors}
                      className="validationText"
                    />
                  )}
                  
                  {serverSuccess ? null :
                    <ButtonGroupContainer>
                      <Button
                        onClick={() => {
                          methods.handleSubmit(onSubmit);
                        }} >
                        {loading ? (
                          <LoadingSpinner show />
                        ) : (
                          "Submit"
                        )}
                      </Button>
                    </ButtonGroupContainer>
                  }
                  <ReCAPTCHA
                    ref={recaptcha}
                    sitekey="6LfU8UspAAAAAGYvuYdOkXrHcGGpuEXM4-hxH7Rh"
                    onChange={handleCaptchaChange}
                  />
                </FormSectionContainer>
              </FormContainer>
            </SectionContainer>
          </Form>
        </FormProvider>
    </>
  );
};
const validationSchema = Yup.object().shape({
    eaid: Yup.string()
    .required(eaid.required)
    .matches(/[\d0-9]+/, {
      message: eaid.format,
      excludeEmptyString: true,
    }),
  phone: Yup.string()
    .required(phone.required)
    .matches(/^\+61[0-9]+$/, {
      message: phone.format,
      excludeEmptyString: true,
    }),
  pinCode: Yup.string().matches(/^\d{4}$/, {
    message: 'Pin must be 4 digits',
    excludeEmptyString: true,
  })
});
